const zh = {
    login:{
        title:'我是标题',
    }
}
export default zh;
